var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".photo-section{margin:.5rem;height:7rem;background-image:url(" + escape(require("../../../static/img/add-card.png")) + ");background-position:50%;background-repeat:no-repeat;background-size:3rem 3rem;padding:.5rem}.photo-section .photo-tips{text-align:center;margin-top:5rem}.photo-section .photo-img{height:100%}.voucher-register-footer{margin-top:1rem}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-0edf8d38","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/modules/voucher/VoucherRegisterPhoto.vue
// module id = 408
// module chunks = 0